/**
 * http 请求服务策略
 * 
 * @export
 * @class FetchService
 */
class LocalstorageService {
    /**
     * Creates an instance of FetchService.
     * 
     * @memberOf FetchService
     */
    constructor() {
    }

    /**
     * 设置本地存储内容
     * 
     * @param {any} key 
     * @param {any} value 
     * @returns 
     * 
     * @memberOf LocalstorageService
     */
    set(key, value) {
        if (window.localStorage) {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        }
        return false;
    }

    /**
     * 获取本地存储里的内容
     * 
     * @param {any} key 
     * @returns 
     * 
     * @memberOf LocalstorageService
     */
    get(key) {
        if (window.localStorage) {
            try {
                return JSON.parse(localStorage.getItem(key));
            } catch (error) {
                return false;
            }
        }
        return false;
    }

    /**
     * 移除本地存储里的内容
     * 
     * @param {any} key 
     * @returns 
     * 
     * @memberOf LocalstorageService
     */
    remove(key) {
        if (window.localStorage) {
            localStorage.removeItem(key);
            return true;
        }
        return false;
    }

    clear() {
        if (window.localStorage) {
            localStorage.clear();
            return true;
        }
        return false;
    }
}

export default new LocalstorageService();